export const baseUrl = "https://movie-lan.fly.dev";
// export const baseUrl = "http://127.0.0.1:8000"
